<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Custom Invoice For Billing</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button style="font-size: 0.675rem; margin-left: 5px" @click="
                proceedAssignmentProforma(
                  ffInvoiceModal.allModuleId,
                  0,
                  ffInvoiceModal.jobNo
                )
                " size="sm" class="ml-1" variant="outline-info">Proceed To Proforma</b-button>
              <!-- :disabled="$sessionsStorage.get('nameUser') != 'Bhavneesh'?true:false" -->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component :allModuleIdBanner="this.allData[0].allModuleId ? this.allData[0].allModuleId : ''
          " :jobSeriesBanner="this.allData[0].ccImportSeries ? this.allData[0].ccImportSeries : ''
            " :bannerClientName="this.allData[0].clientName ? this.allData[0].clientName : ''" iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <div>
              <h4 class="mt-3 error" v-if="sentForApproval == '1' && chnageApprovalStatus != '1'">
                Invoice Sent For Approval
              </h4>
              <div class="box" v-if="PreviousPerformaList.length > 0">
                <div class="box-body row">
                  <div class="col-md-2" v-for="(pre_item, pre_index) in PreviousPerformaList" :key="pre_index">
                    <b-button style="font-size: 0.675rem" class="mt-2" v-if="pre_item.profarmaSeries" size="sm"
                      @click="getPreviousTallyData(pre_item)" variant="info">
                      <b>{{ pre_item.profarmaSeries }}</b>
                    </b-button>
                  </div>
                </div>
              </div>
              <!-- {{ffInvoiceModal}} -->
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Job No.</label>
                    <b-form-input :formatter="capitalizeAll" disabled id="clientName" name="clientName"
                      v-model="ffInvoiceModal.jobNo"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <label for="containerTypeId">Invoice Status</label>
                  <model-list-select :list="invoiceStatusList" v-model="ffInvoiceModal.invoiceStatus" option-value="inv"
                    option-text="int" placeholder="Select Status"></model-list-select>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="45">
              <md-layout md-flex="100">
                <label>Date</label>
                <b-form-input :formatter="capitalizeAll"
                  id="clientName"
                  disabled
                  name="clientName"
                  v-model="ffInvoiceModal.invDate"
                ></b-form-input>
              </md-layout>
                </md-layout>-->
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Client Name</label>
                    <b-form-input :formatter="capitalizeAll" disabled id="clientName" name="clientName"
                      v-model="ffInvoiceModal.clientName"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>CFS Name</label>
                    <model-list-select :list="$store.getters['commonDropdownMaster/getAllLocDDList']"
                      v-model="ffInvoiceModal.fk_cfs_loc_id" option-value="value" option-text="label"
                      placeholder="Select CFS Name">
                    </model-list-select>
                  </md-layout>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Client Contact</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="clientName"
                      name="clientName"
                      v-model="ffInvoiceModal.contact"
                    ></b-form-input>
                  </md-layout>
                </md-layout>-->
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Client Address</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientRegistrationNo" name="clientRegistrationNo"
                      v-model="ffInvoiceModal.adress"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Place Of Receipt</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.POR"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Load Port</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.LP"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Port Of Discharge</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.POD"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Final Place of Delivery</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.FPOD"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45" v-if="newContainerFlow == '0'">
                  <md-layout md-flex="100">
                    <label>Shipping Bill No/ Date(MM/DD/YY)</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.BOE"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5" v-if="newContainerFlow == '0'"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>BL No</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.blNo"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" v-if="newContainerFlow == '0'">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Shipper Invoice No.</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientRegistrationNo" name="clientRegistrationNo"
                      v-model="ffInvoiceModal.shipperInvNo"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Shipper Invoice Date(MM/DD/YY)</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientRegistrationNo" name="clientRegistrationNo"
                      v-model="ffInvoiceModal.shipperInvDate"></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Vessel/Voy</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.vessel"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Weight (KGS)</label>
                    <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.weight"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Shipping Line Name</label>
                    <b-form-textarea :formatter="capitalizeAll" id="clientName" name="clientName"
                      v-model="ffInvoiceModal.shippingLine"></b-form-textarea>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <!-- <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Port Charges Details</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="PortAdditionalCharges"
                      name="PortAdditionalCharges"
                      v-model="ffInvoiceModal.PortAdditionalCharges"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>-->
              </md-layout>
              <md-layout md-gutter class="gutr mt-3">
                <h5>
                  <b-badge>Container Details</b-badge>
                </h5>
              </md-layout>
              <div v-if="newContainerFlow == '1'">
                <table class="table table-sm table-bordered">
                  <tbody>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Container No</th>
                      <th scope="col">Container Type</th>
                      <th scope="col">Shipper Inv.</th>
                      <th scope="col">Shipping Bill</th>
                      <th scope="col">Weight</th>
                    </tr>
                    <tr v-for="(itm, idx) in allNewContainers" :key="idx">
                      <th scope="row">{{ idx + 1 }}</th>
                      <td>{{ itm.containerNo }}</td>
                      <td>{{ itm.containerType }}</td>
                      <td>
                        {{ itm.shipperInvoiceNo }}
                        <br />
                        {{ itm.shipperInvoiceDate }}
                      </td>
                      <td>
                        {{ itm.shippingBillNo }}
                        <br />
                        {{ itm.shippingBillDate }}
                      </td>

                      <td>{{ itm.grossWeight }} {{ itm.weightUnit }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                <md-layout md-gutter>
                  <md-layout md-flex="45">
                    <md-layout md-flex="100">
                      <b-form-input :formatter="capitalizeAll" disabled class="gutr"
                        v-for="(item, index) in ffInvoiceModal.containerDetails" :key="index" id="clientRegistrationNo"
                        name="clientRegistrationNo" :value="item"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="50">
                    <md-layout md-flex="100">
                      <b-form-input :formatter="capitalizeAll" disabled class="gutr"
                        v-for="(item1, index) in ffInvoiceModal.multipleContainerType" :key="index"
                        id="clientRegistrationNo" name="clientRegistrationNo" :value="item1"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                </md-layout>
              </div>
              <Profit-Loss v-if="ffInvoiceModal.allModuleId" :PMS_fk_all_module_id="ffInvoiceModal.allModuleId"
                :PMS_jb_series="ffInvoiceModal.jobNo" :PMS_fk_client_id="ffInvoiceModal.clientName"
                :PLAccordianStatus="false" :PLAccordianButton="true" />
              <Assignment-Timeline :TMAccordianStatus="false" :TMAccordianButton="true"
                :allModuleId="Number(ffInvoiceModal.allModuleId)" />
              <Payment-Summary v-if="ffInvoiceModal.allModuleId" :PMS_fk_all_module_id="ffInvoiceModal.allModuleId"
                :PMS_jb_series="ffInvoiceModal.jobNo" :PMS_fk_client_id="ffInvoiceModal.clientName" />
              <!-- Other Expenses -->
              <!-- <div class="gutr">
                <div class="box-body gutr">
                  <h5>
                    <b-badge variant="info">Expense Details</b-badge>
                  </h5>
                  <table
                    id="otherExpense"
                    class="table table-bordered table-sm gutr"
                  >
                    <tbody>
                      <tr>
                        <th>Expense</th>
                        <th>Amount</th>
                        <th>Remark</th>
                        <th>Added on</th>
                      </tr>
                      <tr
                        v-for="(item, index) in otherExpenseData"
                        :key="index"
                      >
                        <td>
                          {{ item.ledger }}
                        </td>
                        <td>{{ item.amount }}</td>
                        <td>{{ item.remark }}</td>
                        <td>{{ item.loginTime }}</td>
                      </tr>
                      <tr v-if="otherExpenseData.length <= 0">
                        <td colspan="4" style="text-align: center; color: red">
                          <b>NO EXPENSE ADDED</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>-->
              <div class="mt-3">
                <h5>
                  <span class="error mt-4">
                    Note : Approval will be required when Selling Rate is less than
                    Quotation Rate.!
                  </span>
                </h5>
                <br />
                <span class="error mt-1">* marked heads are mandatory..!</span>
              </div>

              <table id="quotationDetail" class="table mt-3 table-light table-bordered">
                <thead>
                  <tr>
                    <th>
                      <b-button v-if="chnageApprovalStatus != '1'" variant="warning" size="sm"
                        @click="addQuotationFields">
                        <!-- @click="addQuotationFields" -->
                        <md-icon>add</md-icon>
                      </b-button>
                    </th>

                    <th style="width: 170px">Particulars*</th>
                    <th>Container Type*</th>
                    <th style="width: 82px">Quantity*</th>
                    <th>Currency*</th>
                    <th style="width: 130px">Quotation Rate</th>
                    <th style="width: 130px">Selling Rate*</th>
                    <th style="width: 100px">Exch Rate*</th>

                    <th style="width: 130px">Invoice Amount(Without Taxes)*</th>

                    <th>Unit</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in ffTallyInvoiceData" :key="index">
                    <td>
                      <b-button size="sm" variant="danger" @click="removeCol(index)">
                        <md-icon>remove</md-icon>
                      </b-button>
                    </td>
                    <!-- <td>{{index+1}}</td> -->
                    <td>
                      <model-list-select :isDisabled="chnageApprovalStatus == '1' ? true : false"
                        :list="$store.getters['common/getAllLedgerList']" v-model="item.ccType" option-value="ledger"
                        option-text="ledger" placeholder="Select Particular">
                      </model-list-select>
                      <!-- <model-list-select
                        :isDisabled="chnageApprovalStatus == '1' ? true : false"
                        :list="ledgerData"
                        v-model="item.ccType"
                        option-value="ledger"
                        option-text="ledger"
                        placeholder="Select Type"
                      ></model-list-select> -->
                      <!-- <b-form-input :formatter="capitalizeAll" :disabled="item.ccTableId!=''?true:false" v-model="item.ccType"></b-form-input> -->
                    </td>
                    <td>
                      <model-list-select :isDisabled="chnageApprovalStatus == '1' ? true : false"
                        :list="containerMasterData" v-model="item.containerType" option-value="containerType"
                        option-text="containerType" placeholder="Select Type"></model-list-select>
                    </td>
                    <td>
                      <b-form-input :formatter="capitalizeAll" :disabled="chnageApprovalStatus == '1' ? true : false"
                        @input="getFinalAmount(index)" type="number" v-model="item.quantity"></b-form-input>
                    </td>
                    <td>
                      <model-list-select :isDisabled="chnageApprovalStatus == '1' ? true : false" :list="currencyList"
                        v-model="item.currency" option-value="currencyV" option-text="currencyT"
                        placeholder="Select"></model-list-select>
                    </td>
                    <td>
                      <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number"
                        :disabled="item.ccSellingRate ? true : false" v-model="item.ccSellingRate"></b-form-input>
                    </td>
                    <td>
                      <b-form-input :formatter="capitalizeAll" :disabled="chnageApprovalStatus == '1' ? true : false"
                        @input="getFinalAmount(index)" type="number" v-model="item.sellingRateFinal"></b-form-input>
                    </td>
                    <td>
                      <!-- :disabled="item.ffSellingRate==''?true:false" -->
                      <b-form-input :formatter="capitalizeAll" :disabled="chnageApprovalStatus == '1' ? true : false"
                        @input="getFinalAmount(index)" type="number" v-model="item.exchRate"></b-form-input>
                    </td>
                    <td>
                      <b-form-input :formatter="capitalizeAll" :disabled="chnageApprovalStatus == '1' ? true : false"
                        v-model="item.invAmount"></b-form-input>
                    </td>

                    <td>
                      <model-list-select :isDisabled="chnageApprovalStatus == '1' ? true : false" :list="unitList"
                        v-model="item.unit" option-value="unitId" option-text="unitName"
                        placeholder="Select"></model-list-select>
                    </td>
                    <td>
                      <b-form-input :formatter="capitalizeAll" v-model="item.remark"></b-form-input>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <label>Job No.</label>
                <b-form-input :formatter="capitalizeAll"
                  disabled
                  id="clientName"
                  name="clientName"
                  v-model="ffInvoiceModal.chnageApprovalStatus"
                ></b-form-input>
              </md-layout>
            </md-layout>
              </md-layout>-->
              <!-- /.box-body -->
              <ExpenseTableComponent
                v-if="ffInvoiceModal.allModuleId && is_noe_validation"
                :show-debug="false"
                :initial-expenses="initialExpenses"
                :enable-validation="true"
                ref="expenseTableComponent"
                @expenses-saved="handleExpensesSaved"
                @expense-validation="handleExpenseValidation"
                :allModuleId="ffInvoiceModal.allModuleId"
                :jobNo="ffInvoiceModal.jobNo"
                :moduleType="'CC'"
                :transportType="'Export'"
                :branchId="$sessionsStorage.get('branch_baseLocation')"
                :invoiceStatus="ffInvoiceModal.invoiceStatus"
              />
              <OldExpenseAdditionalTask
                v-if="ffInvoiceModal.allModuleId"
                :allModuleId="ffInvoiceModal.allModuleId"
                :type="'additional-task'"
              />
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="50">
                  <!-- && sentForApproval=='0') || chnageApprovalStatus=='1' -->
                  <!-- v-if="(validateTally==false && sentForApproval=='0')" -->
                  <b-button class="mt-3" :disabled="(DisableSubmit == '0' || validSubmit == false) &&
                    $store.getters['common/getAllSuccessInvoiceTB']
                      .InvoiceTypeKeyFlag == true
                    ? true
                    : false
                    " v-if="validateTally == false && this.sentForApproval != '1'" variant="primary"
                    @click="submitInvoice('1')" id="addButtonLoader">
                    {{
                      ffInvoiceModal.invoiceStatus == "0"
                        ? "Save & Send To Billing"
                        : "Save & Submit"
                    }}
                  </b-button>
                  <span v-if="updateTime != 'null' && editUserName != 'null'" style="
                      mmargin-top: auto;
                      margin-bottom: auto;
                      padding-top: 20px;
                      margin-left: 20px;
                    ">
                    Last Updated At :
                    <span style="color: red">{{ updateTime }}</span> , By :
                    <span style="color: red">{{ editUserName }}</span><br />
                    <div v-if="
                      $store.getters['common/getAllSuccessInvoiceTB']
                        .BillingSeriesDataString
                    ">
                      Invoice No.
                      <span style="color: red">{{
                        $store.getters["common/getAllSuccessInvoiceTB"]
                          .BillingSeriesDataString
                      }}</span>
                      genrated.
                      <span v-if="
                        $store.getters['common/getAllSuccessInvoiceTB']
                          .InvoiceTypeKeyFlag == true
                      ">Cannot be re-submitted</span>
                    </div>
                  </span>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="20">
                  <!-- ' -->
                  <b-button :disabled="DisableSubmit == '0' ? true : false" class="mt-3"
                    v-if="validateTally == true && this.sentForApproval != '1'" variant="dark"
                    @click="submitInvoice('2')">Send For Approval</b-button>
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopMaxPer"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { getJobNatureOfExpenseList, globalPermissionStatus } from "../../helper/collection";
import PaymentSummary from "../common/paymentSummary.vue";
import AssignmentTimeline from "../common/assignmentTimeline.vue";
import ProfitLoss from "../common/profitLoss.vue";
import ExpenseTableComponent from "../common/expenseTableComponent.vue";
import OldExpenseAdditionalTask from "../allModuleForm/components/OldExpenseAdditionalTask.vue";

export default {
  beforeMount() {
    const storePromises = [
      this.$store.dispatch(
        "common/setAllLedgerList",
        JSON.stringify({
          itemCode: "LedgerList",
          JobType: this.$route.query.JobType,
          ShipmentType: this.$route.query.ShipmentType,
          ModuleType: this.$route.query.ModuleType,
          isLedgerActive: '1',
        })
      ),
      this.$store.dispatch(
        "commonDropdownMaster/setAllLocDDList",
        {
          itemCode: "LocationList",
          locationType: "Vendor/Billing",
          pickupIsActive: 1,
          isSelectedColumn: '1',
          isAll: '1',
          page: 1,
          pageSize: 1,
          generateExcel: 0,
          search_txt: '',
          filter: '',
        }
      ),
    ];
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    if (
      globalPermissionStatus("Custom Clearance") &&
      this.$sessionsStorage.get("editCcImportId") != undefined &&
      this.$sessionsStorage.get("editCcImportId") != "" &&
      this.$sessionsStorage.get("editCcType") != undefined &&
      this.$sessionsStorage.get("editCcType") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCInvoiceForTallyImport");
      Promise.all(storePromises)
        .then(() => delay(5000)) // Wait for 5 seconds
        .then(() => {
          // After the delay, execute the next function
          this.getData();
        })
        .catch((error) => {
          console.error("Error dispatching store actions:", error);
        });
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      PreviousPerformaList: [],
      updateTime: "null",
      editUserName: "null",
      unitList: [],
      allData: [{ allModuleId: null }],
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "0",
          int: "Closed",
        },
      ],
      validateTally: false,
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],
      isLoading: false,
      containerNoName: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      ledgerData: [],
      weightSum: "",
      containerMasterData: [],
      otherExpenseData: [],
      ffInvoiceModal: {
        fk_cfs_loc_id: "",
        chnageApprovalStatus: "",
        invoiceStatus: "1",
        ccInvTallyId: "",
        invDate: "",
        jobNo: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        allModuleId: "",
        ccTypeExImp: "",
        PortAdditionalCharges: "",
        totalAmount: "",
        weight: "",
        vessel: "",
        blNo: "",
        BOE: "",
        shipperInvNo: "",
        shipperInvDate: "",
        clientName: "",
        contact: "",
        adress: "",
        POR: "",
        LP: "",
        POD: "",
        FPOD: "",
        containerDetails: [],
        multipleContainerType: [],

        shippingLine: "",
      },
      DisableSubmit: "",
      newContainerFlow: "",
      sentForApproval: "",
      chnageApprovalStatus: "",
      validateInvoice: true,
      ffTallyInvoiceData: [],
      ccExpInvSummaryData: [],
      allNewContainers: [],
      validSubmit: "",
      expenseValidation: {
        isValid: true,
        messages: [],
        fieldErrors: {}
      },
      initialExpenses: [],
      is_noe_validation: false,
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() { },

  beforeDestroy() { },

  destroyed() { },

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    PaymentSummary,
    ProfitLoss,
    AssignmentTimeline,
    ExpenseTableComponent,
    OldExpenseAdditionalTask,
  },
  watch: {
    ffInvoiceModal: {
      handler: function (newVal, oldVal) {
        if (
          (this.ffInvoiceModal.POR == "" ||
            this.ffInvoiceModal.POD == "" ||
            this.ffInvoiceModal.LP == "" ||
            this.ffInvoiceModal.FPOD == "" ||
            this.ffInvoiceModal.BOE == "" ||
            this.ffInvoiceModal.blNo == "" ||
            this.ffInvoiceModal.shipperInvNo == "" ||
            this.ffInvoiceModal.shipperInvDate == "" ||
            this.ffInvoiceModal.fk_cfs_loc_id == "" ||
            this.ffInvoiceModal.vessel == "" ||
            this.ffInvoiceModal.weight == "" ||
            this.ffInvoiceModal.shippingLine == "") &&
          this.newContainerFlow == "0"
        ) {
          this.validSubmit = false;
        } else {
          this.validSubmit = true;
        }
      },

      deep: true,
    },
  },
  computed: {},
  methods: {
    getJobNatureOfExpenseList() {
      this.is_noe_validation = false; // Reset to false initially
      console.log("allModuleId", this.allModuleId)
      let payload = { module_id: this.ffInvoiceModal.allModuleId, jobNo: this.ffInvoiceModal.mainSalesSeries, moduleType: this.$route.query.ModuleType, };
      getJobNatureOfExpenseList(payload, (error, result) => {
        if (error) {
          console.log("Catch on getNatureOfExpense Error: ", error);
          this.isSubmited = false;
        } else {
          console.log("NatureOfExpense result:", result);
          if (result && result.natureOfExpense) {
            this.natureOfExpense = result.natureOfExpense;
            this.is_noe_validation = result.is_noe_validation;
            // Also populate natureOfExpenseOptions for the dropdown
            // this.natureOfExpenseOptions = [...this.natureOfExpense];
          }
        }
        this.isLoading = false;
      });
    },
    proceedAssignmentProforma(all_module_id, isConsolidation, mainSalesSeries) {
      // newContainerFlow,
      this.$sessionsStorage.set("editSalesExId", all_module_id);
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + all_module_id,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        this.$router.push({
          path: "/common/assignmentPerforma/" + all_module_id,
        });
      }
    },
    getFinalAmount(ind) {
      if (!this.ffTallyInvoiceData[ind].exchRate) {
        this.ffTallyInvoiceData[ind].exchRate = 1;
      }

      let count = 0;
      this.ffTallyInvoiceData[ind].invAmount =
        parseFloat(this.ffTallyInvoiceData[ind].quantity) *
        parseFloat(this.ffTallyInvoiceData[ind].sellingRateFinal) *
        parseFloat(this.ffTallyInvoiceData[ind].exchRate);

      for (let i = 0; i < this.ffTallyInvoiceData.length; i++) {
        if (
          this.ffTallyInvoiceData[i].sellingRateFinal &&
          this.ffTallyInvoiceData[i].ccSellingRate != "Charges As Per Receipt" &&
          this.ffTallyInvoiceData[i].ccSellingRate != "" &&
          this.ffTallyInvoiceData[i].ccSellingRate != undefined
        ) {
          if (
            parseInt(this.ffTallyInvoiceData[i].sellingRateFinal) >=
            parseInt(this.ffTallyInvoiceData[i].ccSellingRate)
          ) {
            //  count++;
            console.log("iu");
            this.validateTally = false;
          } else {
            // console.log(x.ccSellingRate,"tyrt")
            this.validateTally = true;
            break;
            return false;
          }
        }
      }

      // if (count < this.ffTallyInvoiceData.length) {
      //   this.validateTally = true;
      // } else {
      //   this.validateTally = false;
      // }
      //  if (parseInt(this.ffTallyInvoiceData[ind].sellingRateFinal) < parseInt(this.ffTallyInvoiceData[ind].ccSellingRate)) {
      //   this.validateTally = true;

      // } else {
      //   this.validateTally = false;

      // }
      // let count = 0;
      // this.ffTallyInvoiceData.map((x, index) => {
      //   if (x.quantity != "") {
      //     let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
      //     x.invAmount = finalAmt;
      //   }
      // });
    },
    getQuotRate() {
      let count = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.sellingRateFinal != "") {
          if (parseInt(x.sellingRateFinal) >= parseInt(x.ccSellingRate)) {
            count++;
          }
        }
        console.log(typeof x.sellingRateFinal, typeof x.ccSellingRate, "jjj");
      });
      if (count < this.ffTallyInvoiceData.length) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }

      // console.log(
      //   parseInt(item.sellingRateFinal) < parseInt(item.ccSellingRate)
      // );

      // if (item.sellingRateFinal < item.ccSellingRate) {
      //   this.validateTally = true;
      // } else {
      //   this.validateTally = false;
      // }
    },
    submitInvoice(id) {
       this.ffInvoiceModal.expenseData = [];
      this.ffInvoiceModal.totalExpenseAmount = 0;
      // Get all expense data from child component
      let allExpenseData = [];
      if (this.$refs.expenseTableComponent && this.is_noe_validation) {
        // First validate expenses
        const expenseValidationResult = this.$refs.expenseTableComponent.validateExpensesForParent();
        if (!expenseValidationResult) {
          this.alert.content = "Please fix expense validation errors before submitting.";
          this.$refs["addPop"].open();
          return false;
        }

        // Get all expense data using simple common function
        const expenseData = this.getExpenseDataSimple();
        const expenseDataAll = this.getExpenseData();
        console.log("All Expense Data:", expenseData);
        console.log("All Expense Data All:", expenseDataAll);

        // Add to ffInvoiceModal
        this.ffInvoiceModal.expenseData = expenseData.all;
        this.ffInvoiceModal.totalExpenseAmount = expenseData.total;
      }
      for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
        if (!this.ffTallyInvoiceData[r].ccType) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].quantity) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].sellingRateFinal) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].unit) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].invAmount) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else if (!this.ffTallyInvoiceData[r].currency) {
          this.alert.content =
            "Please Enter All Paticulars,Quantity,Selling Rate,Unit,Final Amount,Currency in Charges Section";
          this.$refs["addPop"].open();
          return false;
          break;
        } else {
          console.log("All fields are Entered");
        }
      }

      if (id == "2") {
        this.ffInvoiceModal.invoiceStatus = "1";
      }
      this.ffInvoiceModal["ffTallyInvoiceData"] = this.ffTallyInvoiceData;
      this.ffInvoiceModal["ccImportId"] = this.$sessionsStorage.get("editCcImportId");

      this.ffInvoiceModal["buttonId"] = id;
      let total = 0;

      this.ffTallyInvoiceData.map((x) => {
        let dummy = parseInt(x.invAmount) + total;
        total = dummy;
      });

      this.ffInvoiceModal.totalAmount = total;

      if (this.validateInvoice != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addInvoiceTallyCC.php`,
          data: JSON.stringify(this.ffInvoiceModal),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    removeCol(index) {
      this.ffTallyInvoiceData.splice(index, 1);
    },
    addQuotationFields() {
      let tableFields = {
        ccType: "",
        containerType: "",
        quantity: "",
        buyingRate: "",
        ccSellingRate: "",
        sellingRateFinal: "",
        exchRate: "1",
        invAmount: "",
        currency: "",
        remark: "",
        ccTableId: "",
      };

      this.ffTallyInvoiceData.push(tableFields);
    },
    getData() {
      this.isLoading = true;
      this.weightSum = "";
      this.ffTallyInvoiceData = [];
      let type_Size = {
        itemCode: "itemCode",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: this.$sessionsStorage.get("editCcType"),
        jobType: this.$route.query.JobType,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/fetchToCCTallyInvMain_NewV3.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          console.log(data);
          if (data.ccExpInvSummaryData.length > 0) {
            this.allData = data.ccExpInvSummaryData;
          }
          if (status == 200 && data) {
            if (data.PreviousPerformaList.length > 0) {
              this.PreviousPerformaList = data.PreviousPerformaList;
            }
            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
            if (data.allNewContainers.length > 0) {
              this.allNewContainers = data.allNewContainers;
              if (this.allNewContainers[0].weightUnit) {
                this.weightSum = this.allNewContainers.reduce(
                  (a, b) => +a + +b.grossWeight,
                  0
                );
                this.weightSum =
                  this.weightSum + " " + this.allNewContainers[0].weightUnit;
              }
            } else {
              this.allNewContainers = [];
            }

            if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }
            if (data.containerMasterData.length > 0) {
              this.containerMasterData = data.containerMasterData;
            } else {
              this.containerMasterData = [];
            }
            if (data.otherExpenseData.length > 0) {
              this.otherExpenseData = data.otherExpenseData;
            }

            let TParti = [];
            let TCon = [];
            let TSelO = [];
            let TSF = [];
            let TINV = [];
            let TCUR = [];
            let TRE = [];
            let QUN = [];
            let CON_NO = [];
            let EXRT = [];
            let CONTYPE = [];
            let UN = [];
            if (data.ccExpInvSummaryData) {
              this.newContainerFlow = data.ccExpInvSummaryData[0].newContainerFlow;
            }
            if (data.tallyTableData.length > 0) {
              this.DisableSubmit = data.tallyTableData[0].invoiceStatus;
              this.sentForApproval = data.tallyTableData[0].sentForApproval;
              this.chnageApprovalStatus = data.tallyTableData[0].chnageApprovalStatus;

              Object.keys(data.tallyTableData[0]).map((x) => {
                if (x == "particulars") {
                  if (data.tallyTableData[0][x] != null) {
                    TParti = data.tallyTableData[0][x].split(",");
                  } else {
                    TParti = [];
                  }
                } else if (x == "containerType") {
                  if (data.tallyTableData[0][x] != null) {
                    TCon = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCon = [];
                  }
                } else if (x == "quotationRate") {
                  if (data.tallyTableData[0][x] != null) {
                    TSelO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSelO = [];
                  }
                } else if (x == "sellingRateFinal") {
                  if (data.tallyTableData[0][x] != null) {
                    TSF = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TSF = [];
                  }
                } else if (x == "unit") {
                  if (data.tallyTableData[0][x] != null) {
                    UN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    UN = [];
                  }
                } else if (x == "finalRateWithoutTax") {
                  if (data.tallyTableData[0][x] != null) {
                    TINV = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TINV = [];
                  }
                } else if (x == "currency") {
                  if (data.tallyTableData[0][x] != null) {
                    TCUR = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TCUR = [];
                  }
                } else if (x == "remark") {
                  if (data.tallyTableData[0][x] != null) {
                    TRE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    TRE = [];
                  }
                } else if (x == "quantity") {
                  if (data.tallyTableData[0][x] != null) {
                    QUN = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    QUN = [];
                  }
                } else if (x == "containerDetails") {
                  if (data.tallyTableData[0][x] != null) {
                    CON_NO = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    CON_NO = [];
                  }
                } else if (x == "multipleContainerType") {
                  if (data.tallyTableData[0][x] != null) {
                    CONTYPE = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    CONTYPE = [];
                  }
                } else if (x == "exchRate") {
                  if (data.tallyTableData[0][x] != null) {
                    EXRT = data.tallyTableData[0][x].split(",") || [];
                  } else {
                    EXRT = [];
                  }
                } else {
                  this.ffInvoiceModal[x] = data.tallyTableData[0][x] || "";
                }
              });

              if (CON_NO.length > 0) {
                // this.ffInvoiceModal.containerDetails = CON_NO;
              }
              if (CONTYPE.length > 0) {
                this.ffInvoiceModal.multipleContainerType = CONTYPE;
              }

              if (TParti.length > 0) {
                console.log(TSF);
                TParti.map((x, index) => {
                  let obj = {
                    ccType: x,
                    containerType: TCon[index],
                    quantity: QUN[index],
                    ccSellingRate: TSelO[index],
                    sellingRateFinal: TSF[index],
                    exchRate: EXRT.length > 0 ? EXRT[index] : "1",

                    unit: UN[index],
                    invAmount: TINV[index],
                    currency: TCUR[index],
                    remark: TRE[index],
                  };

                  this.ffTallyInvoiceData.push(obj);
                });
              }
              if (data.users && data.users.length > 0) {
                this.editUserName = data.users[0].employeeName;
                this.updateTime = data.tallyTableData[0].updateTime;
              }
            } else {
              if (data.ccExpInvSummaryData[0].containerDetails) {
                this.ffInvoiceModal.containerDetails = data.ccExpInvSummaryData[0].containerDetails.split(
                  ","
                );
              }
              // console.log(   this.ffInvoiceModal.containerDetails,"dd",data.ccExpInvSummaryData[0].containerDetails)
              if (data.ccExpInvSummaryData[0].multipleContainerType) {
                let firstArr = data.ccExpInvSummaryData[0].multipleContainerType.split(
                  ","
                );

                let searry = data.ccExpInvSummaryData[0].multiConNo.split(",");
                for (let i = 0; i < firstArr.length; i++) {
                  let element = firstArr[i];
                  let runCount = searry[i];
                  for (let y = 0; y < runCount; y++) {
                    console.log(element, runCount, "ooo");
                    this.ffInvoiceModal.multipleContainerType.push(element);
                  }
                }
              }
              this.ccExpInvSummaryData = data.ccExpInvSummaryData;

              this.ffInvoiceModal.fk_cfs_loc_id = data.ccExpInvSummaryData[0].fk_cfs_loc_id;
              this.ffInvoiceModal.clientName = data.ccExpInvSummaryData[0].clientName;
              this.ffInvoiceModal.contact = data.ccExpInvSummaryData[0].kycContact;
              this.ffInvoiceModal.adress = data.ccExpInvSummaryData[0].corporateAddress;
              this.ffInvoiceModal.jobNo = data.ccExpInvSummaryData[0].ccImportSeries;
              this.ffInvoiceModal.shippingLine = data.ccExpInvSummaryData[0].shippingLine;
              this.ffInvoiceModal.POD = data.ccExpInvSummaryData[0].placeDis;
              this.ffInvoiceModal.POR = data.ccExpInvSummaryData[0].placeRecp;
              this.ffInvoiceModal.FPOD = data.ccExpInvSummaryData[0].finalPlace;
              this.ffInvoiceModal.LP = data.ccExpInvSummaryData[0].LoadPort;
              this.ffInvoiceModal.allModuleId = data.ccExpInvSummaryData[0].allModuleId;
              this.ffInvoiceModal.ccImportId = data.ccExpInvSummaryData[0].ccImportId;
              this.ffInvoiceModal.ccTypeExImp = data.ccExpInvSummaryData[0].ccType;
              this.ffInvoiceModal.weight = this.weightSum;

              data.ccExpInvSummaryData[0].ccType;
              if (data.quotationData.length > 0) {
                this.ffTallyInvoiceData = data.quotationData;
              } else {
                this.ffTallyInvoiceData = [];
              }
              if (data.ccShipVoyBLData.length > 0) {
                this.ffInvoiceModal.shipperInvNo = data.ccShipVoyBLData[0].ccShipInvNo;
                if (data.ccShipVoyBLData[0].ccshipInvDate) {
                  let dt = data.ccShipVoyBLData[0].ccshipInvDate.split(",");
                  for (let p = 0; p < dt.length; p++) {
                    this.ffInvoiceModal.shipperInvDate = this.ffInvoiceModal.shipperInvDate.concat(
                      "," + new Date(dt[p]).toLocaleDateString("en-US")
                    );
                  }
                }
                //this.ffInvoiceModal.shipperInvDate=data.ccShipVoyBLData[0].ccshipInvDate;
                var sbDate = "";
                if (data.ccShipVoyBLData[0].ccSbNoDate) {
                  let dt1 = data.ccShipVoyBLData[0].ccSbNoDate.split(",");
                  for (let q = 0; q < dt1.length; q++) {
                    sbDate = sbDate.concat(
                      "," + new Date(dt1[q]).toLocaleDateString("en-US")
                    );
                  }
                }

                this.ffInvoiceModal.BOE = data.ccShipVoyBLData[0].ccSbNo + "\n " + sbDate;
                this.ffInvoiceModal.vessel =
                  data.ccShipVoyBLData[0].vessel + "\n" + data.ccShipVoyBLData[0].voyage;

                // this.ffInvoiceModal.shipperInvNo=data.SBVoyageBlData[0].shipInvDate;
              }
            }
            if (this.ffInvoiceModal.allModuleId) {
              this.$store.dispatch(
                "common/setAllSuccessInvoiceTB",
                JSON.stringify({
                  itemCode: "ALL_SUCCESS_INVOICE_TALLY_BILLING",
                  allModuleId: this.ffInvoiceModal.allModuleId,
                  InvoiceTypeKey: "C",
                })
              );
            }
            this.isLoading = false;
            this.getJobNatureOfExpenseList();
          }
        })
        .catch((error) => { });
    },
    getPreviousTallyData(pre_item) {
      console.log("pre_item=>", pre_item);
      // this.ffInvoiceModal.fromAgentColoderTable = pre_item.fromAgentColoderTable;
      // this.ffInvoiceModal.invoiceForClient = pre_item.invoiceForClient;
      // this.ffInvoiceModal.otherChargeFF = pre_item.otherChargeFF;
      // this.ffInvoiceModal.profarmaLocationId = pre_item.profarmaLocationId;
      // this.ffInvoiceModal.profarmaLocationName = pre_item.profarmaLocationName;
      // this.ffInvoiceModal.shipperInvNoforTally = pre_item.shipperInvNoforTally;
      // this.ffInvoiceModal.shipperInvDateforTally = pre_item.shipperInvDateforTally;
      // this.ffInvoiceModal.shipperInvNo = pre_item.shipperInvNo;
      // this.ffInvoiceModal.shipperInvDate = pre_item.shipperInvDate;
      // this.ffInvoiceModal.stateName = pre_item.stateName;
      // this.ffInvoiceModal.clientgst = pre_item.clientgst;
      // this.ffInvoiceModal.grnNo = pre_item.grnNo;
      // this.ffInvoiceModal.pickup = pre_item.pickup;
      // this.ffInvoiceModal.Handover = pre_item.Handover;
      // this.ffInvoiceModal.factoryLoc = pre_item.factoryLoc;
      // // this.ffInvoiceModal.jobType= pre_item.jobTypeNameArr;
      // // this.ffInvoiceModal.jobTypeName= pre_item.jobTypeNameArr;
      // this.ffInvoiceModal.jobNo = pre_item.jobNo;
      // this.ffInvoiceModal.ffExportFclId = pre_item.ffExportFclId;
      // this.ffInvoiceModal.allModuleId = pre_item.allModuleId;
      // this.ffInvoiceModal.ccTypeExImp = pre_item.ccTypeExImp;
      // this.ffInvoiceModal.weight = pre_item.weight;
      // this.ffInvoiceModal.vessel = pre_item.vessel
      //   ? pre_item.vessel
      //   : this.ffInvoiceModal.vessel;
      // this.ffInvoiceModal.blNo = pre_item.blNo;
      // this.ffInvoiceModal.BOE = pre_item.BOE;
      // this.ffInvoiceModal.clientId = pre_item.clientId;
      // this.ffInvoiceModal.clientName = pre_item.clientName;
      // this.ffInvoiceModal.contact = pre_item.contact;
      // this.ffInvoiceModal.adress = pre_item.adress;
      // this.ffInvoiceModal.POR = pre_item.POR;
      // this.ffInvoiceModal.LP = pre_item.LP;
      // this.ffInvoiceModal.POD = pre_item.POD;
      // this.ffInvoiceModal.FPOD = pre_item.FPOD;
      // this.ffInvoiceModal.shippingLine = pre_item.shippingLine;
      // let BLno = this.ffInvoiceModal.blNo.replace(/ /g, "").split(",");
      // console.log("BLno", BLno);
      // BLno = [...new Set(BLno)];
      // console.log("BLno", BLno);
      // this.ffInvoiceModal.blNo = "";
      // this.ffInvoiceModal.blNo = BLno.join(",");
      // console.log("pre_item", pre_item);
      this.getBillData(pre_item);
    },
    getBillData(item) {
      this.ffTallyInvoiceData = [];
      // Object.keys(this.ffInvoiceModal).map((x, index) => {
      //   if(x!=null && x!=undefined){
      //   this.ffInvoiceModal[x] = item[x];
      //   }
      // });
      let TParti = [];
      let TCon = [];
      let TSelO = [];
      let TSF = [];
      let TINV = [];
      let TCUR = [];
      let TRE = [];
      let QUN = [];
      let CON_NO = [];
      let EXRT = [];
      let CONTYPE = [];
      let UN = [];

      if (item.particulars != null) {
        TParti = item.particulars.split(",");
      }
      if (item.containerType != null) {
        TCon = item.containerType.split(",");
      }
      if (item.quantity != null) {
        QUN = item.quantity.split(",");
      }
      if (item.quotationRate != null) {
        TSF = item.quotationRate.split(",");
      }
      if (item.sellingRateFinal != null) {
        TSelO = item.sellingRateFinal.split(",");
      }
      if (item.unit != null) {
        UN = item.unit.split(",");
      }
      if (item.exchRate) {
        EXRT = item.exchRate.split(",");
      }
      if (item.containerDetails) {
        CON_NO = item.containerDetails.split(",") || [];
      } else {
        CON_NO = [];
      }
      if (item.finalRateWithoutTax != null) {
        TINV = item.finalRateWithoutTax.split(",");
      }
      if (item.currency != null) {
        TCUR = item.currency.split(",");
      }
      if (item.remark != null) {
        TRE = item.remark.split(",");
      }

      if (TParti.length > 0) {
        TParti.map((x, index) => {
          let obj1 = {
            ccType: x,
            containerType: TCon[index],
            quantity: QUN[index],
            ccSellingRate: TSelO[index],
            sellingRateFinal: TSF[index],
            exchRate: EXRT.length > 0 ? EXRT[index] : "1",

            unit: UN[index],
            invAmount: TINV[index],
            currency: TCUR[index],
            remark: TRE[index],
          };

          this.ffTallyInvoiceData.push(obj1);

          // this.CCCheckDone = 1;
        });

        // this.revisedSavedBillingData = this.ffTallyInvoiceData;
      }
    },
    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/paymentDetail"
      // });
    },
    handleExpensesSaved(expenses) {
      console.log('Expenses saved:', expenses);
      // Handle the saved expenses data
    },

    handleExpenseValidation(validationData) {
      this.expenseValidation = validationData;
      console.log('Expense validation:', validationData);
    },

    // Method to get expense data from child component
    getExpenseData() {
      if (this.$refs.expenseTableComponent) {
        return this.$refs.expenseTableComponent.getAllExpensesData();
      }
      return [];
    },

    // Simple common function to get all expense data
    getExpenseDataSimple() {
      if (!this.$refs.expenseTableComponent) {
        return { all: [], total: 0 };
      }

      const allExpenses = this.$refs.expenseTableComponent.getAllExpensesDataComplete();
      const total = allExpenses.reduce((sum, exp) => {
        return sum + (parseFloat(exp.amountToBePaid) || 0) + (parseFloat(exp.amountToBeBilled) || 0);
      }, 0);

      return { all: allExpenses, total };
    },

  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// CCInvoiceForTallyExport.vue?c135ae74